<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-2">Approve Payment</p>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="3">
            <p class="caption">Tenant:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="9">
            <p class="caption font-weight-bold">{{ tenantName }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="3">
            <p class="caption">Total:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="9">
            <p class="caption font-weight-bold">
              {{ formatCurrency(total) }}
            </p>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <!-- <transition name="fade" mode="out-in"> -->
        <div v-if="step == 1" key="1">
          <v-row>
            <v-col class="py-2" cols="12" sm="12" md="12">
              <p>Are you sure you would like to approve payment {{ refNo }}?</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-2" cols="12" sm="12" md="12">
              <v-checkbox v-model="confirmSendEmail" class="my-0" hide-details>
                <template v-slot:label> Send email to tenant </template>
              </v-checkbox>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="font-weight-bold"
              color="primary"
              text
              @click="finish()"
              >Yes</v-btn
            >
            <v-btn
              class="font-weight-bold"
              color="grey darken-1"
              text
              @click="cancel"
              >No</v-btn
            >
          </v-card-actions>
        </div>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { formatCurrency } from '../../util/currency'
export default {
  data() {
    return {
      formatCurrency,
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      loading: true,
      paidPaymentId: -1,
      refNo: -1,
      tenantName: '',
      total: 0,
      creditBalance: null,
      step: 1,
      confirmSendEmail: false
    }
  },
  methods: {
    async open(payment) {
      this.loading = true
      this.dialog = true
      this.total = parseFloat(payment.total)
      this.paidPaymentId = payment.paidPaymentId
      this.tenantName = payment.tenantName
      this.refNo = payment.refNo
      this.step = 1
      this.confirmSendEmail = false

      this.loading = false
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      this.loading = true
      if (
        await this.$store.dispatch('payments/approvePaidPaymentAction', {
          paidPaymentId: this.paidPaymentId,
          confirmSendEmail: this.confirmSendEmail
        })
      ) {
        this.$root
          .$confirm({
            title: 'Approve Payment',
            message: `The payment has been approved.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(() => {
            this.loading = false
            this.dialog = false
            this.resolve(this.paidPaymentId)
          })
      } else {
        this.$root
          .$confirm({
            title: 'Approve Payment',
            message: `There was an error processing your request.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(() => {
            this.loading = false
          })
      }
    },
    cancel() {
      this.dialog = false
      this.loading = false
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
